import { ViewOwnershipType } from '@baserow/modules/database/viewOwnershipTypes'

/**
 * Vistas personales: solo las ve quien las creo.
 *
 * Todo el peso esta en el backend (extras_mg/permission_managers.py), que es
 * quien filtra y niega. Esto solo la ofrece al crear una vista. Nombre propio
 * (mg_personal) para no montarse sobre la implementacion de premium, que sigue
 * registrada y sigue pidiendo licencia.
 */
export class VistaPersonalMGOwnershipType extends ViewOwnershipType {
  static getType() {
    return 'mg_personal'
  }

  getName() {
    return 'Personal'
  }

  getDescription() {
    return 'Solo tu la ves. Sirve para filtrar y ordenar a tu gusto sin cambiarle la vista a los demas.'
  }

  getIconClass() {
    return 'iconoir-lock'
  }

  isDeactivated() {
    return false
  }

  getListViewTypeSort() {
    // Debajo de las colaborativas, que son las que usa todo el mundo.
    return 60
  }
}

/**
 * "Mis asuntos": la vista de quien solo ve las filas donde está en Personas
 * (extras_mg/asignados). Una por persona y tabla, con el filtro guardado
 * "Personas tiene <su id>"; la crea y la arregla el sistema.
 *
 * Aquí solo lo que el navegador necesita para usarla: no se ofrece al crear
 * una vista, y el tiempo real va por su propia página (`mg_asignados`), que
 * solo manda las filas que pasan su filtro. La de la tabla, que manda todas,
 * se la niega el servidor.
 */
export class SoloAsignadosMGOwnershipType extends ViewOwnershipType {
  static getType() {
    return 'mg_solo_asignados'
  }

  getName() {
    return 'Mis asuntos'
  }

  getDescription() {
    return 'Solo las filas donde estás en Personas.'
  }

  getIconClass() {
    return 'iconoir-user'
  }

  isCompatibleWithViewType(viewType) {
    return viewType.type !== 'form'
  }

  userCanTryCreate() {
    return false
  }

  getListViewTypeSort() {
    return 10
  }

  supportsPresenceFocus() {
    // La presencia diría quién más mira la tabla y en qué celda.
    return false
  }

  enhanceRealtimePagePayload(database, table, view, payload) {
    payload.page = 'mg_asignados'
    payload.params = { vista_id: view.id }
    return payload
  }
}
